import React from 'react';
import { useStyletron } from 'baseui';
import { BooleanColumn, CustomColumn, StringColumn } from 'baseui/data-table';

import { CustomDateColumn, EBooleanStatus, EMPTY_STRING } from 'commons-ui';
import { getSuccessErrorBackground } from './listConfigStyle';

export const COL_NAMES = {
	_id: '_id',
	name: 'name',
	description: 'description',
	flowOrScreensImpacted: 'flowOrScreensImpacted',
	created: 'created',
	start: 'start',
	end: 'end',
	isExpired: 'isExpired',
	isRunning: 'isRunning',
	buckets: 'buckets',
	isLive: 'isLive',
	isAllowed: 'isAllowed',
	createdBy: 'createdBy'
};

export const columnConfigs = [
	StringColumn({
		title: 'MongoDB ID',
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES._id] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Name',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.name]
	}),
	StringColumn({
		title: 'Description',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.description] || 'N/A'
	}),
	StringColumn({
		title: 'Flow/Screens Impacted',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.flowOrScreensImpacted] || 'N/A'
	}),
	CustomDateColumn({
		title: 'Start Date',
		minWidth: 170,
		maxWidth: 200,
		columnName: COL_NAMES.start
	}),
	CustomDateColumn({
		title: 'End Date',
		minWidth: 170,
		maxWidth: 200,
		columnName: COL_NAMES.end
	}),

	CustomDateColumn({
		title: 'Created at',
		minWidth: 170,
		maxWidth: 200,
		columnName: COL_NAMES.created
	}),
	BooleanColumn({
		title: 'Running on app',
		maxWidth: 150,
		mapDataToValue: (data: any) => data[COL_NAMES.isRunning]
	}),
	CustomColumn({
		title: 'Is Allowed',
		mapDataToValue: (data: any) => data[COL_NAMES.isAllowed] || EMPTY_STRING,
		maxWidth: 100,
		renderCell: (params: any) => {
			const { value } = params;
			const text: string = value ? EBooleanStatus.YES : EBooleanStatus.NO;
			const [css] = useStyletron();
			return <div className={css(getSuccessErrorBackground(value))}>{text}</div>;
		}
	}),
	StringColumn({
		title: 'Created by',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	},
	sortDetails: [
		{
			field: '_id',
			order: 'DESC'
		}
	]
};
